<template>
	<div class="m-1">
		<b-modal ref="publish-modal" size="mg" id="modal-center" centered hide-footer title="还款优惠">
			<div>

				<div class="pb-1" v-if="payType!=''">本次支付方式：<span class="text-primary"><strong>
							<span v-if="payType=='wechatPay'">微信支付</span>
							<span v-if="payType=='aliPay'">支付宝</span>
						</strong></span></div>


				<div class="pb-1">本次合计支付：<span
						class="text-primary"><strong>{{this.formatCurrency(totalRepay/100)}}</strong></span>元</div>
				<div class="pb-1">本次优惠金额：<span
						class="text-primary"><strong>{{this.formatCurrency(reductAmt/100)}}</strong></span>元</div>
				<div>实际支付金额：<span class="text-primary"><strong>{{this.formatCurrency(netRepay/100)}}</strong></span>元
				</div>

				<b-overlay :show="isPaying" rounded="sm" style="font-size: 90%;text-align: center;" class="p-1">
					<span v-if="isPaying" class="text-primary">稍等...</span>
				</b-overlay>

				<div class="d-flex justify-content-end mr-3 mt-3">
					<b-button variant="secondary" class="ml-3" @click="hideModal" v-if="!isPaying"> 取消</b-button>
					<b-button variant="success" class="ml-3" @click="confirmPay" v-if="!isPaying">继续支付 </b-button>
				</div>
			</div>

		</b-modal>
	</div>
</template>
<script>
	export default {
		components: {},
		data() {
			return {
				reductAmt: 0,
				totalRepay: 0,
				netRepay: 0,
				openid: "",
				repayInfo: null,
				isPaying: false,
				payType: "",
				waitTimer: 0,
				timeOut: 0,
				callParent: null,
			}
		},

		methods: {
			toast(toaster, append = false) {
				this.$bvToast.toast(toaster, {
					title: `提示`,
					toaster: "b-toaster-top-center",
					solid: true,
					variant: "danger",
					appendToast: append
				})
			},

			formatCurrency(value) {
				if (!value) return '0.00';
				return new Intl.NumberFormat('zh-CN', {
					style: 'currency',
					currency: 'CNY'
				}).format(value);
			},

			showModal(repayInfo, _openid, netRepay, reductAmt, totalRepay, _payType, callParent) {
				this.reductAmt = reductAmt;
				this.totalRepay = totalRepay;
				this.netRepay = netRepay;
				this.openid = _openid;
				this.repayInfo = repayInfo;
				this.isPaying = false;
				this.payType = _payType
				this.callParent = callParent
				this.$refs['publish-modal'].show()
			},

			hideModal() {
				this.$refs['publish-modal'].hide()
			},

			waitResult(refNo) {
				let that = this;
				let _openid = localStorage.getItem("_openid")
				this.$axios.get(that.$DOMAIN() + "/wechatApi/wechat/unified/repay/payResult/" + refNo, {
						headers: {
							"openid": _openid,
						}
					})
					.then(function(response) {
						console.log("payResult--->response====>", response)
						if (response.data.result == "FAIL") {
							that.toast("还款支付失败:" + response.data.failReason)
							that.isPaying = false
							clearInterval(that.waitTimer)
						} else if (response.data.result == "SUCCESS") {
							that.toast("还款支付成功")
							that.isPaying = false
							that.hideModal()
							clearInterval(that.waitTimer)
							if (that.callParent != null) {
								that.callParent()
							}
						} else {
							if (that.timeOut > 9) {
								that.toast("还款支付中,请稍后查询支付结果.")
								that.isPaying = false
								clearInterval(that.waitTimer)
								that.hideModal()
								if (that.callParent != null) {
									that.callParent()
								}
							} else {
								that.timeOut++
							}
							that.isPaying = true;
						}
					})
					.catch(function(error) {
						console.log(error)
					});
			},

			confirmPay() {
				let that = this;
				const unixTimestamp = Math.floor(Date.now() / 1000);
				localStorage.setItem("_lastime", unixTimestamp)
				this.isPaying = true;
				this.$forceUpdate()
				if (that.repayInfo.channelNo == "SHYPay") {
					console.log("this.repayInfo=====>", this.repayInfo)
					this.$axios.post(that.$DOMAIN() + "/wechatApi/payease/createOrder", this.repayInfo, {
							headers: {
								"openid": this.openid,
							}
						})
						.then(function(response) {
							console.log("=====>",response)
							//ACCEPTED
							if(response.data.data.result=="ACCEPTED"){
								that.toast("短信验证码已成功发送")
								console.log("requestRefNo=====>",response.data.data.requestRefNo)
								that.hideModal()
								that.callParent(response.data.data.requestRefNo)
							}
						})
						.catch(function(error) {
							that.toast(error.response.data.errmsg)
							console.log(error)
						});
						
				} else {
					console.log("this.repayInfo=====>", this.repayInfo)
					this.$axios.post(that.$DOMAIN() + "/wechatApi/wechat/unified/repay/confirmPay", this.repayInfo, {
							headers: {
								"openid": this.openid,
							}
						})
						.then(function(response) {
							if (that.repayInfo.channelNo == "YC") {
								console.log(response.data.result)
								if (response.data.result == "ACCEPT") {
									that.requestNo = response.data.requestNo
									that.timeOut = 0;
									that.waitTimer = setInterval(function() {
										that.waitResult(that.requestNo)
									}, 3000);
								} else if (response.data.result == "SUCCESS") {
									that.toast("还款成功")
									that.isPaying = false;
									that.hideModal()
								} else if (response.data.result == "FAIL") {
									that.toast(response.data.failReason)
									that.isPaying = false;
									that.hideModal()
								}
							} else {
								if (response.data.result == "SUCCESS") {
									window.location.href = response.data.ftUrl;
								} else {
									that.toast(response.data.failReason)
									that.hideModal()
								}
							}
						})
						.catch(function(error) {
							that.toast(error.response.data.errmsg)
							console.log(error)
						});
				}

			},
		}

	}
</script>

<style>

</style>
